/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-useless-catch */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import styled, { ThemeProvider } from 'styled-components';
import theme from '@vr/lib/styles/theme';
import { GlobalStyle } from '@vr/lib';
import axios from 'axios';
import { Mapa } from '@vr/mapa';
import Cookies from 'js-cookie';
import getImagemProduto from './helpers/getImagemProduto';
import getAccessToken from './helpers/auth-helper';
import useReCaptcha from './hook/use-recaptcha';

const OptionProduto = styled.div`
  img {
    width: 60px;
    margin-right: 23px;
  }
`;

const products = [
  '00031', // VR Refeição
  '00027', // VR Alimentação
  '00028', // VR Auto
  '00203', // VR Compras
  '00030', // VR Cultura
];

const productsMapper = {
  '00031': 'REFEICAO',
  '00027': 'ALIMENTACAO',
  '00028': 'AUTO',
  '00203': 'COMPRAS',
  '00030': 'CULTURA',
};

const productsCodeMapper = {
  REFEICAO: 31,
  ALIMENTACAO: 27,
  AUTO: 28,
  COMPRAS: 203,
  CULTURA: 30,
};

function App(props) {
  const [locations, setLocations] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const { recaptchaRef, ready, execute } = useReCaptcha({
    siteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
    badge: 'bottomright',
    hl: 'pt-BR',
  });

  const findLocations = async filter => {
    if (!ready) {
      return;
    }

    setIsLoading(true);

    try {
      const params = {
        latitude: filter.lat,
        longitude: filter.lon,
        raio: filter.raio || 1,
        distancia: filter.raio,
        delivery: filter.delivery || false,
        produto: productsMapper[filter.produto],
        termo: filter.estabelechiment,
        pagina: 1,
        tamanho: 100,
      };

      const clientId = process.env.REACT_APP_SENSEDIA_CLIENT_ID;

      let accessToken = Cookies.get('access_token');

      if (!accessToken) {
        accessToken = await getAccessToken(clientId);
      }

      const recaptchaToken = await execute();

      const headers = {
        Emissor: 'VRPAT',
        client_id: clientId,
        access_token: accessToken,
        tokenRecaptcha: recaptchaToken,
      };

      const { data } = await axios.get(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_REDE_CREDENCIADA_PATH}`,
        {
          params,
          headers,
        },
      );

      const estabelecimentos = data.result.dados.map(item => {
        return {
          ...item,
          id: item.cnpj,
          cnpj: item.cnpj,
          nome: item.nomeFantasia,
          endereco: `${item.endereco.tipo} ${item.endereco.descricao}, ${item.endereco.numero} - ${item.endereco.bairro}`,
          cidade: item.endereco.cidade,
          estado: item.endereco.estado,
          cep: item.endereco.cep,
          latitude: item.localizacao.latitude.toString(),
          longitude: item.localizacao.longitude.toString(),
          produtos: item.produtos.map(produto => productsCodeMapper[produto]),
        };
      });

      setLocations(estabelecimentos);
    } catch (e) {
      console.error(e);
      setLocations([]);
    } finally {
      setIsLoading(false);
    }
  };

  function renderOption(item) {
    const image = getImagemProduto(item.code);
    return (
      <OptionProduto>
        {image && <img src={image} alt={item.name} />}
        {item.name}
      </OptionProduto>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <Mapa
        findEstablishment={findLocations}
        locations={locations}
        products={products}
        isLoading={isLoading}
        renderOption={renderOption}
        showResumoResultados
        open
        {...props}
      />
      <div ref={recaptchaRef} />
      <GlobalStyle />
    </ThemeProvider>
  );
}

export default App;
